export default {"src":"/_next/static/media/Icon_POI_selected_m.62924dfd.svg","height":40,"width":32};